module.exports = __webpack_public_path__ + "static/media/3DPPA41.cb92c98c.jpg";